import { InfoCircleOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React from 'react';
import styles from './LeadsCreationPendingInfoAlert.module.css';

type Props = {
  className?: string;
  title: string;
  description: string;
};

export const LeadsCreationPendingInfoAlert = (props: Props) => {
  const { className, title, description } = props;
  return (
    <div className={classNames(styles.container, className)}>
      <InfoCircleOutlined className={styles.infoIcon} />

      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </div>
  );
};
